import { menuModule } from '@/api'
import { ResWrap, service, IdRequestParam } from '@/utils/request'
import { pa } from './lang'

/**
 * GameGroupAddRequest
 */
export interface IMenuGroupAddRequest {
  /**
   * 分组名称
   */
  menuId?: number
  menuName?: String
  menuType: String
  isFrame?: String
  isCache?: String
  parentId?: number
  path?: number
  perms?: String
  status?: String
  visible?: String
  icon?: String
  createTime?: String
  orderNum?: String
  remark?: String
}
export interface IMenuListRequest {
  /**
   * 分组名称
   */
  pageSize?: number
  pageNo?: number
  menuName?: String
  status?: String
}

/**
 * void
 *
 * Response«List«EmployeeGroupResponse»»
 */
export interface IMenuGroupResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: MenuGroupResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * EmployeeGroupResponse
 */
export interface MenuGroupResponse {
  menuId: number
  menuName?: String
  menuType: String
  isFrame?: String
  isCache?: String
  parentId?: number
  path?: number
  perms?: String
  status?: String
  visible?: String
  icon?: String
  createTime?: String
  orderNum?: String
  remark?: String
}
export interface IRouterResponseParam {
  code?: string
  msg?: string
  data?: IRouterDataResponseParam
}
export interface IRouterDataResponseParam {
  name?: string
  path?: string
  hidden?: boolean
  redirect?: string
  component?: string
  alwaysShow?: boolean
  meta?: string
  children: Array<IRouterDataResponseParam>
}
/**
 * 新增菜单分组
 */
export function addMenu(param: IMenuGroupAddRequest): Promise<ResWrap<null>> {
  return service.post(`${menuModule.menuAddApi}`, param)
}
/**
 * 编辑菜单分组
 *
 * @param param
 */
export function editMenu(param: IMenuGroupAddRequest): Promise<ResWrap<null>> {
  return service.put(`${menuModule.menuAddApi}`, param)
}

/**
 * 删除菜单分组
 *
 * @param param
 */
export function delMenu(param: IdRequestParam): Promise<ResWrap<null>> {
  return service.delete(`${menuModule.menuDelApi + '/' + param.id}`)
}

/**
 * 列表菜单分组
 */
export function menuAllList(param: IMenuListRequest): Promise<IMenuGroupResponseParam> {
  return service.get(`${menuModule.menuListApi}?status=${param.status}&menuName=${param.menuName}`)
}

/**
 * 获取路由参数
 */
export function getRouters(): Promise<IRouterResponseParam> {
  return service.get(`${menuModule.getRoutersApi}`)
}
